import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';
import mainColors from '../../main-colors';
import sizeStandards from '../../size-standards';

const StyledToastContainer = styled(ToastContainer)`
  @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
    max-width: 260px;
    top: 16px;
    right: 16px;
    left: unset;
    padding: 4px;
  }

  .Toastify__toast {
    margin: 8px 0;
    padding: 0;
    border-radius: 6px;
    box-shadow: 0px 0px 5px 2px ${mainColors.text_color};

    .toast-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 8px;

      svg {
        max-width: 40px;
      }

      .success-icon {
        fill: ${mainColors.main_color};
      }

      .info-icon {
        fill: ${mainColors.dark_background};
        opacity: 0.6;
      }

      .error-icon {
        fill: ${mainColors.error_color};
        @media only screen and (min-width: ${sizeStandards.screen.SM}px) {
          margin: 0 4px;
        }
      }
    }

    .Toastify__progress-bar-theme--light {
      background: inherit;
    }

    .Toastify__progress-bar {
      height: 5px;
      background: ${mainColors.main_color};
      opacity: 1;
    }
  }
`;

export default StyledToastContainer;
